export function buildStyles(): string {
  return `
:host {
  all: initial;
  font-family: var(--cw-font-family);
  color: var(--cw-text);
}

*, *::before, *::after { box-sizing: border-box; }

.launcher {
  position: fixed;
  width: 64px;
  height: 64px;
  border: none;
  border-radius: 9999px;
  background: linear-gradient(135deg, var(--cw-primary), var(--cw-primary-dark, #991b1b));
  color: #fff;
  box-shadow: 0 12px 28px rgba(0,0,0,.25);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--cw-z);
  transition: transform .15s ease, box-shadow .15s ease;
}
.launcher:hover { transform: scale(1.05); }
.launcher svg { width: 28px; height: 28px; fill: none; stroke: currentColor; stroke-width: 2; }

.panel {
  position: fixed;
  width: var(--cw-width);
  height: var(--cw-height);
  max-width: calc(100vw - 24px);
  max-height: calc(100vh - 24px);
  background: var(--cw-bg);
  color: var(--cw-text);
  border-radius: var(--cw-radius);
  box-shadow: 0 20px 50px rgba(0,0,0,.28);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: var(--cw-z);
  font-size: 14px;
  line-height: 1.45;
}

.pos-bottom-right .launcher, .pos-bottom-right .panel { right: 24px; bottom: 24px; }
.pos-bottom-left .launcher, .pos-bottom-left .panel { left: 24px; bottom: 24px; }
.pos-top-right .launcher, .pos-top-right .panel { right: 24px; top: 24px; }
.pos-top-left .launcher, .pos-top-left .panel { left: 24px; top: 24px; }

.header {
  background: linear-gradient(90deg, var(--cw-primary), var(--cw-primary-dark, #991b1b));
  color: #fff;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  user-select: none;
}
.header h2 { margin: 0; font-size: 16px; font-weight: 700; }
.header-actions {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}
.icon-btn {
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.icon-btn:hover { background: rgba(255,255,255,.18); }
.icon-btn svg { width: 18px; height: 18px; }

.body {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--cw-bg);
}

.welcome-hero {
  background: linear-gradient(180deg, var(--cw-primary), var(--cw-primary-dark, #991b1b));
  color: #fff;
  text-align: center;
  padding: 24px 16px;
}
.welcome-hero h3 { margin: 0 0 8px; font-size: 11px; letter-spacing: .08em; opacity: .9; }
.welcome-hero h2 { margin: 0; font-size: 22px; }
.welcome-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 20px;
  gap: 16px;
}
.welcome-cta p { margin: 0; text-align: center; color: #374151; font-weight: 500; }
.primary-btn {
  border: none;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(90deg, var(--cw-primary), var(--cw-primary-dark, #991b1b));
  border-radius: 9999px;
  padding: 12px 28px;
  font-weight: 600;
  font-size: 14px;
}
.primary-btn:disabled { opacity: .65; cursor: not-allowed; }

.messages { padding: 16px; display: flex; flex-direction: column; gap: 14px; }
.row { display: flex; gap: 8px; }
.row.user { justify-content: flex-end; }
.row.agent { justify-content: flex-start; }
.avatar {
  width: 32px; height: 32px; border-radius: 9999px; flex-shrink: 0; margin-top: 4px;
  background: var(--cw-primary); color: #fff; display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 700;
}
.bubble-wrap { max-width: 80%; min-width: 0; }
.bubble-wrap.user { max-width: 70%; }
.agent-name { margin: 0 0 4px 4px; font-size: 11px; font-weight: 600; color: #4b5563; }
.bubble {
  padding: 12px 14px;
  border-radius: 16px;
  word-break: break-word;
  overflow-wrap: anywhere;
  font-size: 13px;
}
.bubble.user {
  background: #e5e7eb;
  color: #1f2937;
  border-top-right-radius: 4px;
}
.bubble.agent {
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  color: #1f2937;
  border-top-left-radius: 4px;
}
.bubble.agent p { margin: 0 0 8px; }
.bubble.agent p:last-child { margin-bottom: 0; }
.bubble.agent ul, .bubble.agent ol { margin: 0 0 8px; padding-left: 18px; }
.bubble.agent li { margin: 2px 0; }
.bubble.agent strong { font-weight: 700; color: #111827; }
.bubble.agent a { color: var(--cw-primary); text-decoration: underline; }
.bubble.agent code {
  background: #f3f4f6; color: var(--cw-primary); padding: 1px 4px; border-radius: 4px; font-size: 12px;
}
.bubble.agent pre {
  background: #111827; color: #f3f4f6; padding: 10px; border-radius: 8px; overflow-x: auto; margin: 8px 0;
}
.bubble.agent pre code { background: transparent; color: inherit; padding: 0; }
.bubble.agent h1, .bubble.agent h2, .bubble.agent h3, .bubble.agent h4 {
  margin: 8px 0 4px; font-weight: 700; color: #111827;
}
.bubble.agent h1 { font-size: 15px; }
.bubble.agent h2 { font-size: 14px; }
.bubble.agent h3, .bubble.agent h4 { font-size: 13px; }
.meta { margin: 4px 4px 0; font-size: 11px; color: #9ca3af; }
.meta.user { text-align: right; }

.chips { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 8px; }
.chip {
  border: 1.5px solid #e5e7eb;
  background: #fff;
  border-radius: 12px;
  padding: 8px 14px;
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  text-align: left;
}
.chip:hover { border-color: var(--cw-primary); color: var(--cw-primary); }

.typing { display: flex; gap: 4px; align-items: center; height: 18px; }
.typing span {
  width: 7px; height: 7px; border-radius: 9999px; background: #9ca3af;
  animation: bounce 1s infinite;
}
.typing span:nth-child(2) { animation-delay: .15s; }
.typing span:nth-child(3) { animation-delay: .3s; }
@keyframes bounce {
  0%, 80%, 100% { transform: translateY(0); opacity: .5; }
  40% { transform: translateY(-4px); opacity: 1; }
}

.input-bar {
  border-top: 1px solid #f3f4f6;
  padding: 12px 14px;
  background: var(--cw-bg);
}
.input-row { display: flex; gap: 8px; align-items: center; }
.input-row input {
  flex: 1;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  padding: 10px 14px;
  font-size: 13px;
  outline: none;
  font-family: inherit;
  color: var(--cw-text);
  background: #fff;
}
.input-row input:focus { border-color: var(--cw-primary); box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.25); }
.send-btn {
  border: none; background: transparent; color: var(--cw-primary); cursor: pointer; padding: 8px; border-radius: 8px;
}
.send-btn:disabled { color: #d1d5db; cursor: not-allowed; }
.send-btn svg { width: 20px; height: 20px; }
.ended { text-align: center; color: #4b5563; font-size: 13px; margin: 0; padding: 8px 0; }

.tabs {
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-around;
  padding: 8px 4px;
  background: var(--cw-bg);
}
.tab {
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 10px;
  border-radius: 10px;
  color: #4b5563;
  font-size: 11px;
  font-weight: 500;
  font-family: inherit;
}
.tab.active { color: var(--cw-primary); background: rgba(220, 38, 38, 0.08); }
.tab svg { width: 18px; height: 18px; }

.overlay {
  position: absolute; inset: 0; z-index: 20;
  background: rgba(0,0,0,.5);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
}
.form-card {
  width: 100%; max-width: 340px; background: #fff; border-radius: 16px; overflow: hidden;
  box-shadow: 0 16px 40px rgba(0,0,0,.25);
}
.form-card .form-header {
  background: linear-gradient(90deg, var(--cw-primary), var(--cw-primary-dark, #991b1b));
  color: #fff; padding: 14px 18px;
}
.form-card .form-header h3 { margin: 0; font-size: 16px; }
.form-card .form-header p { margin: 4px 0 0; font-size: 12px; opacity: .9; }
.form-body { padding: 18px; display: flex; flex-direction: column; gap: 12px; }
.form-body label { display: block; font-size: 12px; font-weight: 600; color: #374151; margin-bottom: 4px; }
.form-body input, .form-body textarea {
  width: 100%; border: 1px solid #d1d5db; border-radius: 10px; padding: 10px 12px;
  font-size: 13px; font-family: inherit; outline: none;
}
.form-body input:focus, .form-body textarea:focus { border-color: var(--cw-primary); }
.form-error {
  background: #fef2f2; border: 1px solid #fecaca; color: #dc2626;
  border-radius: 8px; padding: 8px 10px; font-size: 12px;
}
.form-success { color: #16a34a; font-size: 13px; font-weight: 600; margin: 0; }
.req { color: #dc2626; }
.opt { color: #9ca3af; font-weight: 400; }
.faq-list, .news-list { padding: 16px; display: flex; flex-direction: column; gap: 8px; }
.section-label {
  margin: 0 0 4px 4px; font-size: 11px; font-weight: 600; color: #6b7280;
  text-transform: uppercase; letter-spacing: .04em;
}
.faq-item, .news-item {
  border: 1px solid #f3f4f6; border-radius: 12px; background: #fff;
  padding: 14px; text-align: left; cursor: pointer; width: 100%;
  font-family: inherit; color: inherit; text-decoration: none; display: block;
}
.faq-item:hover, .news-item:hover { border-color: #fca5a5; }
.faq-q { margin: 0; font-size: 13px; font-weight: 600; color: #111827; }
.faq-cat { margin: 4px 0 0; font-size: 11px; color: #6b7280; }
.news-item .label { margin: 0 0 6px; font-size: 11px; font-weight: 600; color: #6b7280; text-transform: uppercase; }
.news-item h3 { margin: 0 0 8px; font-size: 14px; color: #111827; }
.news-item p { margin: 0 0 8px; font-size: 12px; color: #4b5563; }
.news-item .cta { color: #2563eb; font-size: 12px; font-weight: 600; }

.hidden { display: none !important; }

@media (max-width: 480px) {
  .panel {
    width: calc(100vw - 16px) !important;
    height: calc(100dvh - 16px) !important;
    right: 8px !important; left: 8px !important; bottom: 8px !important; top: auto !important;
  }
}
`;
}
